import { render, staticRenderFns } from "./ModalVersionDetails.vue?vue&type=template&id=bc8a0abc&scoped=true&"
import script from "./ModalVersionDetails.vue?vue&type=script&lang=js&"
export * from "./ModalVersionDetails.vue?vue&type=script&lang=js&"
import style0 from "./ModalVersionDetails.vue?vue&type=style&index=0&id=bc8a0abc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8a0abc",
  null
  
)

export default component.exports